import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Fetches the Firestore users/{uid} document.
 */
export async function getUserDoc(uid: string) {
  if (!uid) {
    throw new Error('getUserDoc: uid is required');
  }

  const ref = doc(db, 'users', uid);
  return getDoc(ref);
}

/**
 * Ensures a minimal users/{uid} document exists. Does NOT set role for new users;
 * they must go through /select-role or lazy migration.
 *
 * - If the doc is missing: create with id, email, status, createdAt, updatedAt
 *   (no role/userType so getPostAuthRoute sends to /select-role).
 * - If it exists but has no userType/role: leave unchanged (lazy migration or select-role handles it).
 * - Otherwise: leave it unchanged.
 *
 * Idempotent and safe to call on every login.
 */
export async function ensureUserDoc(uid: string, email?: string | null) {
  if (!uid) {
    throw new Error('ensureUserDoc: uid is required');
  }

  const ref = doc(db, 'users', uid);
  const existing = await getDoc(ref);

  const now = serverTimestamp();

  if (existing.exists()) {
    return existing;
  }

  await setDoc(
    ref,
    {
      id: uid,
      email: email ? email.toLowerCase() : null,
      status: 'active',
      onboardingCompleted: false,
      createdAt: now,
      updatedAt: now,
      emailSentAt: {},
      featureFirstUse: {},
      emailMeta: {},
    },
    { merge: true },
  );

  return getDoc(ref);
}


